export function recruiterSignupStep(
  accountReady: boolean,
  segmentCount: number,
  termsAccepted: boolean,
): number {
  if (!accountReady) return 0;
  if (segmentCount === 0) return 1;
  if (!termsAccepted) return 2;
  return 3;
}

export function canAccessKycStep(step: number, identityVerified: boolean): boolean {
  return step === 0 || identityVerified;
}
